import { Box, Text } from '@chakra-ui/layout';
import type { MouseEventHandler } from 'react';

export const ChartError = ({
  message,
  onClick,
}: {
  message?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}) => {
  return (
    <Box
      width="100%"
      height="100%"
      padding={4}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
    >
      <Text textAlign="center" fontSize="lg" fontWeight="bold">
        Data Unavailable
      </Text>
      {message ? (
        <Text textAlign="center" fontSize="sm" marginTop={2} noOfLines={3}>
          {message}
        </Text>
      ) : (
        <Text textAlign="center" fontSize="md" marginBottom={4}>
          Our team has been notified and is working on a fix. Please try again
          in about an hour.
        </Text>
      )}
    </Box>
  );
};
